import { CUSTOM_ELEMENTS_SCHEMA, NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ErrorComponent } from './components/error/error.component';
import { EnsureModuleLoadedOnceGuard } from './guards/module-loaded-once.guard';
import { GlobalLoaderComponent } from './components/global-loader/global-loader.component';
import { TranslocoRootModule } from '../transloco-root.module';



@NgModule({
  declarations: [ErrorComponent, GlobalLoaderComponent,],
  imports: [
    CommonModule,
    RouterModule,
    TranslocoRootModule
  ],
  exports: [ErrorComponent, GlobalLoaderComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CoreModule extends EnsureModuleLoadedOnceGuard { 
  constructor(@Optional() @SkipSelf() parentModule: CoreModule){
    super(parentModule);
  }
}
